import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 10px;
  height: 12px;
  color: var(--wg-blue-link);
`

const CarrotLeft = ({ title = 'Previous', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 10 16" title={title} {...rest}>
    <path
      d="M8 2L2 8l6 6"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    />
  </StyledIcon>
)

CarrotLeft.displayName = 'CarrotLeft'
CarrotLeft.needsWork = true
export default CarrotLeft
